import React from 'react';
import { TextArea } from '@beisen/chaos-ui';
import transLoader from '@beisen/i18n-translation-loader';

const defaultTranslation = {
  inputHolder: '点击填写',
  required: '必填'
};
class FormulaTextarea extends React.Component {
  constructor(props) {
    super(props);
    this.translation = Object.assign({}, defaultTranslation, transLoader({
        inputHolder: 'fieldPlaceHolder.inputHolder',
        required: 'common.required'
    }), props.translation);
  }

  render() {
    const { cmp_label } = this.props;
    return (
      <TextArea
        type="text"
        label={cmp_label}
        isReadOnly={true}
        value={this.props.text || ''}
        translation={this.translation}
        desc={this.props.cmp_data.desc}
      />
    );
  }
}
export default FormulaTextarea;



// WEBPACK FOOTER //
// ./src/components/Field_Components/FormulaTextarea/FormulaTextarea.js